<template>
    <div class="container container--budget">  

        <Loader v-if="!ready"></Loader>

        <article class="budget" v-if="ready">

            <header class="budget__heading">
                <h1 class="woocommerce-order-details__title">Budget {{ budget.libelle }}</h1>
                <div class="budget__heading__date">
                    <p>
                        <strong>Valide du <Date :date="budget.validiteStartAt" /> au <Date :date="budget.validiteEndAt" /></strong>
                        &nbsp;
                        <Badge type="warning" v-if="budget.code && !budget.isActive">Inactif</Badge>
                        <Badge type="success" v-if="budget.code && budget.isActive">Actif</Badge>
                        <Badge type="secondary" v-if="!budget.code">En attente</Badge>
                    </p>
                </div>
                <div class="budget__heading__actions">
                    <button class="button alt" title="Modifier"
                        v-if="$can('MODIFIER_BUDGET') && $setting('BUDGET_UPDATE_ENABLED')"
                        v-on:click="edit()">Modifier</button>
                </div>
            </header>         
            
            <div class="budget__details">
                <ul class="woocommerce-order-overview woocommerce-thankyou-order-details order_details">
                    <li class="woocommerce-order-overview__order order">Code : <strong>{{ budget.code }}</strong></li>
                    <li class="woocommerce-order-overview__order order">Libellé : <strong>{{ budget.libelle }}</strong></li>
                    <li class="woocommerce-order-overview__order order">Crédit restant / total : <strong><Price :amount="budget.amountRemaining" /> / <Price :amount="budget.amount" /></strong></li>
                    <li class="woocommerce-order-overview__order order">Périodicité : <strong>{{ budget.periodicite }} mois</strong></li>
                    <li class="woocommerce-order-overview__order order">Remise à zéro le : <strong><Date :date="budget.nextPeriodAt" v-if="budget.nextPeriodAt" /><span v-else>—</span></strong></li>
                </ul>
            </div>  

            <aside class="budget__commandes">

                <table class="woocommerce-orders-table woocommerce-MyAccount-orders shop_table shop_table_responsive my_account_orders account-orders-table">

                    <thead>
                        <tr>
                            <th class="woocommerce-orders-table__header woocommerce-orders-table__header-order-number">Commande</th>
                            <th class="woocommerce-orders-table__header">Ref. client</th>
                            <th class="woocommerce-orders-table__header woocommerce-orders-table__header-order-date">Émise le</th>
                            <th class="woocommerce-orders-table__header">État</th>
                            <th class="woocommerce-orders-table__header">Total HTT</th>
                        </tr>
                    </thead>

                    <tbody>    

                        <tr v-if="budget.commandes.length == 0" class="woocommerce-orders-table__row">
                            <td class="woocommerce-orders-table__cell woocommerce-orders-table__cell-no-result" colspan="5">Aucune commande</td>
                        </tr>            

                        <tr v-else class="woocommerce-orders-table__row order commande-item"
                            v-for="commande in budget.commandes"
                            v-on:click="viewCommande(commande)"
                            :key="commande.id">
                            <td class="woocommerce-orders-table__cell woocommerce-orders-table__cell-order-number">{{ commande.num || 'En cours n°' + commande.id }}</td>
                            <td class="woocommerce-orders-table__cell">{{ commande.engagementNum }}</td>
                            <td class="woocommerce-orders-table__cell woocommerce-orders-table__cell-order-date"><Date :date="commande.createdAt" /></td>
                            <td class="woocommerce-orders-table__cell"><CommandeStatus :commande="commande" /></td>
                            <td class="woocommerce-orders-table__cell"><Price :amount="commande.amountHTT" :currency="commande.currency" /></td>
                        </tr>
                    </tbody>

                </table>

            </aside>

        </article>

    </div>
</template>

<script>
import { mapState } from 'vuex'

import { actions } from '@/store/budgets'

import title from "@/containers/title"

import Badge from '@/components/badge/Badge.vue'
import CommandeStatus from '@/components/commandeStatus/CommandeStatus.vue'
import Date from '@/components/date/Date.vue'
import Price from '@/components/price/Price.vue'
import Loader from '@/components/loader/Loader.vue'
import Router, { routes } from '@/router'

export default {

    name: 'Budget',

    computed: mapState({

        budget: state => state.budgets.current,

        ready: state => ( state.budgets.current !== null )

    }),

    methods: {

        edit: function() {
            Router.push({
                name: routes.BUDGET_EDIT,
                params: { id: this.budget.id } 
            });
        },

        viewCommande: function(commande) {

            Router.push({
                name: routes.COMMANDE,
                params: { id: commande.id } 
            });
        }
    },
  
    created () {
        this.$store.dispatch(actions.GET, this.$route.params.id)
            .then( () => this.setTitle( 'Budget ' + this.budget.libelle ) )            
            .catch(error => {
                this.$errorPage(error.reason)
            })
    },

    components: {
        Badge,
        CommandeStatus,
        Date,
        Loader,
        Price,
    },

    mixins: [ title ]
}
</script>

<style>

.budget {
    position: relative;
}

.budget__heading {
    margin-bottom: 2rem;
    padding-top: 4rem; 
}

.budget__heading__actions {
    position: absolute;
    right: 0;
    top: 0;
}

.budget__heading__actions > *:not(:first-child) {
    margin-left: 1rem !important;
}

.budget__footer {
}

.budget__footer__actions {
    text-align: right;
}

.negative {
    color: rgb(255, 48, 0);
}

.commande-item:not(.is-unknown) {
    cursor: pointer;
}

.commande-item:not(.is-unknown):hover {
    color: rgb(0, 0, 0);
    background-color: rgba(13, 197, 193, 0.7);
}  

</style>
